"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const joi = require("@hapi/joi");
exports.PaginationSchema = joi
    .object({
    limit: joi.number().integer().positive(),
    offset: joi.number().integer().min(0),
    sort: joi.string(),
    direction: joi.string().valid('asc', 'desc'),
})
    .with('sort', 'direction')
    .with('direction', 'sort');



// WEBPACK FOOTER //
// ./node_modules/@soluto-private/serverless-pagination/dist/src/schema/PaginationSchema.js